import { LibraryDownloadTypes } from "tools/library/store/types";
import createReducersFromTypes from "store/createReducersFromTypes";

export default createReducersFromTypes(LibraryDownloadTypes);
